var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-title"},[_c('img',{staticClass:"u-no",attrs:{"src":_vm.titleImgUrl,"alt":"01"}}),_c('img',{staticClass:"u-text",attrs:{"src":_vm.subtitleImgUrl,"alt":"资料片预览"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }